import api from './utilBackoffice';

const controller = 'Arquivo3040Estruturadas';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  UploadEstruturadas: dto => {
    return api.Axios.Post(url + '/UploadEstruturadas', dto);
  },
  Download: dto => {
    return api.Axios.DownloadExcelFile(url + '/Download', dto);
  },
  GetEstruturadas: dto => {
    return api.Axios.GetParams(url + '/GetAllEstruturadas', dto);
  }
});
